export default __webpack_public_path__ + "static/media/alexus_foster.ec801f47.jpeg";